module.exports = __webpack_public_path__ + "img/13.a60330d8.gif";